import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import LangSwitch from "./LangSwitch";
import SiteSwitch from "./SiteSwitch";
import ThemeToggle from "./ThemeToggle";

const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

export default function NavTurista() {
    const { t } = useI18n();
    return (
        <nav
            data-testid="itly-nav-turista"
            className="itly-nav"
            style={{ position: "sticky", top: 0, zIndex: 40, width: "100%" }}
        >
            <div
                className="itly-nav-inner"
                style={{
                    maxWidth: 1280,
                    margin: "0 auto",
                    padding: "18px 32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 24,
                }}
            >
                <div className="itly-nav-logo-group" style={{ display: "flex", alignItems: "center", gap: 18 }}>
                    <Link
                        to="/"
                        onClick={scrollTop}
                        data-testid="itly-logo"
                        aria-label={t("logo.backToTop")}
                        className="itly-logo-link"
                        style={{ display: "inline-flex", alignItems: "center", gap: 12, textDecoration: "none" }}
                    >
                        <img
                            src="/assets/itly/logo-turista.png"
                            alt="ITLY"
                            data-testid="itly-logo-img"
                            style={{
                                width: 44, height: 44, borderRadius: 12,
                                objectFit: "contain", objectPosition: "center",
                                display: "block", background: "#8BAFC7",
                            }}
                        />
                        <span className="itly-wordmark">ITLY</span>
                    </Link>
                    <span className="itly-siteswitch-desktop"><SiteSwitch /></span>
                </div>

                <div className="itly-nav-links" style={{ display: "flex", alignItems: "center", gap: 32 }}>
                    <a href="#mappa" className="itly-nav-link" data-testid="nav-mappa">{t("nav.map")}</a>
                    <a href="#manifesto" className="itly-nav-link" data-testid="nav-manifesto">{t("nav.manifesto")}</a>
                    <a href="#waitlist" className="itly-nav-link" data-testid="nav-waitlist">{t("nav.waitlist")}</a>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <span className="itly-lang-desktop-only" style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
                        <ThemeToggle />
                        <LangSwitch />
                    </span>
                    <a
                        href="#waitlist"
                        data-testid="nav-cta-waitlist"
                        className="itly-btn-primary itly-cta-glow"
                        style={{ padding: "10px 18px", fontSize: 14 }}
                    >
                        {t("nav.ctaJoin")}
                    </a>
                </div>
            </div>
            {/* Mobile-only second row: site switch (left) · theme + language (right) */}
            <div className="itly-nav-subrow" data-testid="nav-subrow">
                <SiteSwitch />
                <span style={{ display: "inline-flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
                    <ThemeToggle />
                    <LangSwitch compact />
                </span>
            </div>
        </nav>
    );
}
